import { faSignal } from '@fortawesome/pro-solid-svg-icons';
import { EmptyState as RocketlaneEmptyState, Loader } from '@rocketlane/ui';
import { Timeline } from 'api/timeline/types';
import React from 'react';
import styled from 'styled-components';
import { TimelineSignalCard } from 'components/organisms/signal-output/timeline-signal-card';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

const SIDEBAR_PADDING = '24px';

const SignalsSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${SIDEBAR_PADDING} ${SIDEBAR_PADDING} var(--spacing-03);
`;

const EmptyStateRoot = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-08);
`;

interface EmailSignalsSidebarProps {
  timeline?: Timeline | null;
  isLoading?: boolean;
}

export const EmailSignalsSidebar: React.FC<EmailSignalsSidebarProps> = ({
  timeline,
  isLoading,
}) => {
  const signalOccurrences = timeline?.signalOccurrences ?? [];

  if (isLoading) {
    return (
      <EmptyStateRoot>
        <Loader />
      </EmptyStateRoot>
    );
  }

  if (signalOccurrences.length === 0) {
    return (
      <EmptyStateRoot>
        <RocketlaneEmptyState
          icon={{ icon: faSignal }}
          message="No signals detected"
          description="No signals were found for this email."
        />
      </EmptyStateRoot>
    );
  }

  return (
    <Root>
      <SignalsSection>
        {signalOccurrences.map((signal, index) => (
          <TimelineSignalCard
            key={signal.signalOccurrenceId}
            title={signal.title}
            description={signal.summary}
            people={
              signal.reportedByUsers?.length > 0
                ? signal.reportedByUsers
                : (signal.reportedBy ?? [])
            }
            reason={signal.fields?.[0]}
            signalType={signal.signalType}
            signalName={signal.signalName}
            createdAt={
              signal.createdAt ? new Date(signal.createdAt) : undefined
            }
            citations={signal.citationMapping}
            isFirst={index === 0}
            signalOccurrenceId={signal.signalOccurrenceId}
          />
        ))}
      </SignalsSection>
    </Root>
  );
};
